import { PageTitle } from "@/components/shared/title/page-title";
import React from "react";
import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { LocationsPage } from "./LocationsPage";
import { LocationProvider } from "./context/Location";
import { LocationTypeProvider } from "./context/LocationType";

const Location = () => {
	return (
		<>
			<PageTitle title="Locations Management" />
			<LocationProvider>
				<LocationTypeProvider>
					<RootTypeProvider>
						<LocationsPage />
					</RootTypeProvider>
				</LocationTypeProvider>
			</LocationProvider>
		</>
	);
};

export default Location;
